import styles from "./BlogCard.module.scss";
import cn from "clsx";
import { pushToDataLayer } from "@/helpers/gtag";
import dayjs from "dayjs";
import { getGlobalStateValue } from "@/context/utils";
import { imgPathReplace } from "@/helpers/imgPathReplace";
import UnivoLink from "@/components/common/UnivoLink";
import UnivoImage from "@/components/common/UnivoImage";
import { memo } from "react";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";

function BlogCard({
  Heading,
  url_key,
  BannerImage,
  updatedAt,
  ReadTimeText,
  PrimaryCategory,
  isBlogList = false,
  user,
  Tags = [],
  id,
  priority = false,
}: any) {
  const img1 = strapiSingleAttribute(BannerImage);
  const provider = ReadTimeText?.text;

  const GAEventsHandler = (category) => {
    pushToDataLayer({
      event: "card_interaction",
      cta_text: Heading,
      section_name: category || "NA",
      page_type: getGlobalStateValue("pageType"),
    });
    webEngage();
  };
  const author = strapiSingleAttribute(user)?.name;

  const webEngage = () => {
    window?.webengage?.track("Blog Viewed", {
      "Blog Title": Heading,
      Author: author,
      "Page Url": window.location.href,
      "Blog Category Name": PrimaryCategory,
      "Read duration": new Date(updatedAt),
      Tags: Tags.join(", "),
      Date: new Date(updatedAt),
    });
  };

  return (
    <UnivoLink
      id={`blog-card-${id}`}
      onClick={() =>
        GAEventsHandler(PrimaryCategory?.split("_")?.join(" "))
      }
      href={url_key ? `/${url_key}` : "#"}
      target="_self"
      className={`block border-[0.0625rem] border-blu rounded-2xl lg:rounded-[0.833rem] lg:h-[25rem] ${styles.root}`}
      prefetch={false}
      // next/link `scroll` is forwarded by UnivoLink at runtime; not in UnivoLinkProps yet
      {...({ scroll: Boolean(url_key) } as object)}
    >
      <div
        className={cn("flex flex-col justify-end", styles.content, {
          [styles.gradient]: isBlogList,
        })}
      >
        <UnivoImage
          id="readystep-img"
          src={imgPathReplace(img1?.url)}
          alt={img1?.alternativeText || "Amity Online"}
          className="lg:rounded-[0.833rem]"
          width={324}
          height={290}
          title="Amity Online"
          sizes="(max-width: 1024px) 90vw, 324px"
          priority={priority}
          isLcp={priority}
          loading={priority ? undefined : "lazy"}
        />

        {PrimaryCategory && isBlogList && (
          <p className={cn(styles.strip)}>
            {PrimaryCategory?.split("_")?.join(" ")}
          </p>
        )}
      </div>
      <div className={`font-raleway ${styles.bottom}`}>
        <div className={`font-bold flex items-center ${styles.heading}`}>
          {dayjs(updatedAt).format("MMM DD, YYYY")} .{" "}
          <UnivoImage
            src="https://amityonline.com/_s/time_e8c8f780bf.webp"
            alt="clock icon"
            className={`mx-1 ${styles.clockIcon}`}
            width={20}
            height={20}
            sizes="20px"
            loading="lazy"
            fetchPriority="low"
          />
          {provider}
        </div>
        <div className={`font-semibold line-clamp-2  ${styles.text}`}>
          {Heading}
        </div>
        <div className={`${styles.arrow} ${styles.blogArrow}`}>
          <UnivoImage
            src={imgPathReplace(
              "https://amityonline.com/_s/iconmonstr_arrow_right_circle_thin_f882a47d7c.webp",
            )}
            loading="lazy"
            fetchPriority="low"
            alt="news stories"
            width={42}
            height={42}
            sizes="42px"
            title="News Stories"
          />
        </div>
      </div>
    </UnivoLink>
  );
}

export default memo(BlogCard);
